import { Text } from '@doordash/design-language'
import * as React from 'react'
import { TextElement, TextItem } from './styles'

const Item = ({ textItem, idx }) => (
  <TextElement>
    {textItem.subtitle && (
      <Text styles={Text.Styles.Bold18}>{textItem.subtitle}</Text>
    )}
    {textItem.text.map(text => (
      <TextItem
        styles={Text.Styles.PageDescriptionBody}
        key={`${text.slice(0, 10)}${idx}`}
      >
        {text}
      </TextItem>
    ))}
  </TextElement>
)

export default Item
